import { Tooltip_Trigger_default } from "./chunk-YSKC4WSD.js";
import { Tooltip_default } from "./chunk-7VWK4M2W.js";

// src/components/Tooltip/index.ts
var TooltipComponent = Tooltip_default;
TooltipComponent.Trigger = Tooltip_Trigger_default;
TooltipComponent.Trigger.displayName = "Tooltip.Trigger";
export { TooltipComponent };